<template>
  <div :class="['px-6', isTranslationPattern]">
    <div v-if="getUpdateList.length > 0 && getUpdateList.includes(id)">
      {{ initData() }}
    </div>

    <div v-if="getCodeForRunAnswer != null">{{ processResult() }}</div>
    <div v-if="getCodeDeleteResults">{{ deleteResults() }}</div>
    <div v-if="getCodeInputData.step == 1">{{ prepareInputData() }}</div>
    <div v-if="getCodeKernelReset">{{ processKernelReset() }}</div>

    <v-card :elevation="0" v-if="code_update_finished">
      <v-card-text>
        <v-layout
          row
          wrap
          v-for="(item, index) in Cells"
          :key="index"
          :style="
            index == activeContentIndex
              ? { 'border-style': 'solid', 'border-width': '1px 1px 1px 5px' }
              : {}
          "
        >
          <v-flex xs12>
            <div
              v-if="item.cell_type == cellTypes[0]"
              v-html="item.html"
              class="etype-xread-content--combined"
            ></div>
            <div v-if="item.cell_type == cellTypes[1]">
              <v-layout>
                <v-flex xs11 class="pr-6">
                  <codemirror
                    v-if="activeContentIndex == index"
                    @focus="prepareCellEdit(index)"
                    @blur="saveCellContent()"
                    :options="
                      getCmOptions(
                        item.metadata.readOnly,
                        3,
                        item.metadata.showLines
                      )
                    "
                    v-model="activeTmpContent"
                  />
                  <codemirror
                    v-if="activeContentIndex != index"
                    @focus="prepareCellEdit(index)"
                    @blur="saveCellContent()"
                    :options="
                      getCmOptions(
                        item.metadata.readOnly,
                        3,
                        item.metadata.showLines
                      )
                    "
                    :value="getData(index)"
                  />
                </v-flex>
                <v-flex xs1 class="align-self-center">
                  <div v-if="runnable">                                     
                    <v-icon small
                      v-if="item.metadata.runnable && item.metadata.version > 0"
                      @click="loadOriginalCode(index)"
                      title="Load original code"
                      style="margin-right:5px"
                      >reset_tv</v-icon>
                    <v-icon small
                      v-if="item.metadata.runnable && item.metadata.version > 0"
                      @click="loadCodeVersion(index, -1)"
                      title="Newer version of code"
                      >remove_circle_outline</v-icon>  
                      <span v-if="item.metadata.version > 0">{{ item.metadata.version }}</span>
                    <v-icon small
                      v-if="item.metadata.runnable && item.metadata.version > 0"
                      @click="loadCodeVersion(index, 1)"
                      title="Older version of code"
                      >add_circle_outline</v-icon>  
                      <br>
                    [{{ item.execution_count }}]
                    <v-icon
                      large
                      v-if="item.metadata.runnable"
                      @click="runCode(index)"
                      title="Run code"
                      >play_arrow</v-icon>
                  </div>
                </v-flex>
              </v-layout>
              <v-card
                rounded
                v-if="item.outputs.length > 0 || item.temp.parentHeader != null"
                :elevation="0"
                class="my-2"
              >
                <v-card-text class="pa-0 relative">
                  <v-icon class="btn-close" @click="item.outputs = []"
                    >close</v-icon
                  >
                  <div v-for="(item2, index2) in item.outputs" :key="index2">
                    <pre
                      v-if="item2.atype == 'text'"
                      class="py-4 px-8 border-radius-md"
                      >{{ item2.output }}</pre
                    >
                    <div v-if="item2.atype == 'png'">
                      <v-slider
                        v-model="item2.slider"
                        class="align-self-stretch"
                        min="10"
                        max="500"
                        step="1"
                      ></v-slider>
                      <v-img
                        :src="'data:image/png;base64,' + item2.output"
                        :width="(item2.width * item2.slider) / 100"
                      />
                    </div>
                  </div>
                  <v-text-field
                    outlined
                    dense
                    v-if="item.temp.parentHeader != null"
                    autofocus
                    v-model="item.temp.data"
                    :label="item.temp.inputText + ' (and press Enter)'"
                    @keydown.enter.prevent="sendInputData(index)"
                  />
                </v-card-text>
              </v-card>
            </div>
            <div v-if="item.cell_type == cellTypes[2]" v-html="item.html"></div>
            <VueMathjax
              v-if="item.cell_type == cellTypes[3]"
              :formula="getData(index)"
              :options="getFormulaOption()"
            />
            <div v-if="item.cell_type == cellTypes[4]" v-html="item.html"></div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { codemirror } from "vue-codemirror";
// import {Kernel} from '@jupyterlab/services';
// import { KernelMessage, Kernel } from '@jupyterlab/services';
//import * as services from '@jupyterlab/services';
// import { ServiceManager} from '@jupyterlab/services';
import { VueMathjax } from "vue-mathjax";
import { quillEditor } from "vue-quill-editor";
import "codemirror/lib/codemirror.css";
import * as es from "../../assets/editor_settings.js";
import axios from "../../axios-auth";
// import { XMLHttpRequest } from "xmlhttprequest";
// import { default as WebSocket } from 'ws';
import {
  prepareJupyterTextContent,
  deleteHTMLJupyterPart,
} from "../../assets/misc.js";
//import JptrCore from './jptr_core.vue'

export default {
  data() {
    return {
      Cells: [],
      cellTypes: ["editor", "code", "markdown", "equation", "raw"],
      activeContentIndex: -1,
      activeTmpContent: "",
      //activeTmpFormula: 'my eq ||sum_(i=1)^n i^3=((n(n+1))/2)^2[[1,2],[3,4]]||',
      code_update_finished: false
    };
  },
  props: {
    id: Number,
    format: String,
    my_element: String,
    my_elementA: Array,
    objectChangePermission: Boolean,
    runnable: Boolean,
    user_course_id: Number,
    task_id : Number
  },
  computed: {
    ...mapGetters([
      "getUpdateList",
      "getCodeForRunAnswer",
      "getCodeDeleteResults",
      "getCodeInputData",
      "getCodeKernelReset",
    ]),
    isTranslationPattern() {
      return this.$route.name === "task_edit" ? "ma-2" : "ma-0";
    },
  },
  mounted() {
    this.initData();
  },
  components: {
    codemirror,
    quillEditor,
    VueMathjax,
    //    JptrCore
  },
  methods: {
    getEditorOption() {
      return es.getEditorOption();
    },
    getFormulaOption() {
      return es.getFormulaOption();
    },
    getFormulaOptionLatex() {
      return es.getFormulaOptionLatex();
    },
    getCmOptions(_readOnly, _lines = 1, _line_numbers = true) {
      return es.getCmOptionsLines(
        "text/x-python",
        _readOnly,
        _lines,
        _line_numbers
      );
    },
    initData() {      
      this.$store.commit("deleteFromUpdateList", this.id); // if refresh from user
      this.code_update_finished = false
      this.Cells = [];
      
      if (this.format == "json") {
        if (this.my_element.length > 0)
          this.Cells = JSON.parse(this.my_element);
      }
      if (this.format == "json-content") {
        if (this.my_element.length > 0)
          this.Cells = JSON.parse(this.my_element).content;
      }
      if (this.format == "array") {
        this.Cells = JSON.parse(JSON.stringify(this.my_elementA))
      }

      for (let i = 0; i < this.Cells.length; i++) {
        this.Cells[i].execution_count = 0
        this.Cells[i].html = prepareJupyterTextContent(this.Cells[i].source)
        this.Cells[i].temp = {}
        if (this.Cells[i].metadata.runnable == null)
          this.Cells[i].metadata.runnable = true
        if (this.Cells[i].metadata.showLines == null)
          this.Cells[i].metadata.showLines = true
        if (this.Cells[i].metadata.readOnly == null)
          this.Cells[i].metadata.readOnly = false
        this.Cells[i].metadata.version = 0  
      }

      if (this.user_course_id > -1) {
        this.preparePersonalCodes()
      } else {
        this.code_update_finished = true
      }
    },
    getData(_index) {
      var _dt = "";
      for (let i = 0; i < this.Cells[_index].source.length; i++)
        _dt += this.Cells[_index].source[i];
      return _dt;
    },
    prepareCellEdit(_index) {
      this.saveCellContent(false);
      this.activeContentIndex = _index;
      this.activeTmpContent = "";
      for (let i = 0; i < this.Cells[_index].source.length; i++) {
        this.activeTmpContent += this.Cells[_index].source[i];
      }
    },
    saveCellContent(_leaving = true) {
      if (this.activeContentIndex == -1) return;
      // treba doplnit ze len pri userview, nie pri adminovi - treba dat readonly pre admina vo vzorovom okne
      if (this.user_course_id > -1 && this.task_id > -1) {
        if (_leaving && this.Cells[this.activeContentIndex].cell_type == this.cellTypes[1]) {
          const _original = this.Cells[this.activeContentIndex].source.join('')
          if (_original != this.activeTmpContent) {
            // user_course, task_id, id as component_id, index in cells, content
            this.saveCode(this.activeContentIndex, this.activeTmpContent)
          }            
        }
      }

      this.textToCell(this.activeContentIndex, this.activeTmpContent)
      if (this.Cells[this.activeContentIndex].cell_type == this.cellTypes[2])
        this.Cells[this.activeContentIndex].html = prepareJupyterTextContent(
          this.Cells[this.activeContentIndex].source
        );
      else this.Cells[this.activeContentIndex].html = this.activeTmpContent;
    },
    runCode(_index) {
      const _data = {
        // sekcia lebo element/answer z ktoreho to ide
        index: _index,
        code: this.Cells[_index].source.join(""),
        execution_count: this.Cells[_index].execution_count,
      };
      this.Cells[_index].execution_count =
        this.Cells[_index].execution_count + 1;
      this.Cells[_index].outputs = [];
      this.$store.commit("setCodeForRun", _data);
    },
    processResult() {
      const _answer = this.getCodeForRunAnswer;
      this.$store.commit("setCodeForRunAnswer", null);
      const _data = {
        output: _answer.result.outputs,
        atype: _answer.atype,
        width: _answer.width,
        slider: 100,
      };
      this.Cells[_answer.index].outputs.push(_data);
    },
    prepareInputData() {
      this.$store.commit("setCodeInputData", {
        step: 2,
        parentHeader: this.getCodeInputData.parentHeader,
        inputText: this.getCodeInputData.inputText,
        data: "",
        index: this.getCodeInputData.index,
      });
      this.Cells[this.getCodeInputData.index].temp = {
        parentHeader: this.getCodeInputData.parentHeader,
        inputText: this.getCodeInputData.inputText,
        data: "",
      };
    },
    sendInputData(_index) {
      this.$store.commit("setCodeInputData", {
        step: 3,
        parentHeader: this.Cells[_index].temp.parentHeader,
        inputText: "",
        data: this.Cells[_index].temp.data,
        index: _index,
      });
      this.Cells[_index].outputs.push({
        output:
          this.Cells[_index].temp.inputText +
          " " +
          this.Cells[_index].temp.data,
        atype: "text",
      });
      this.Cells[_index].temp = {};
    },
    processKernelReset() {
      this.$store.commit("setCodeKernelReset", false);
      this.Cells.forEach((item) => {
        item.temp = {};
      });
    },
    deleteResults() {
      this.$store.commit("setCodeDeleteResults", false);
      this.Cells.forEach((item) => {
        item.outputs = [];
        item.execution_count = 0;
      });
    },
    saveCode(_index, _content) {
      if (this.task_id == -1 || this.user_course_id == -1) return

      const _data = {
        user_course_id : this.user_course_id,
        task_id : this.task_id,
        component_id : this.id, // not used now
        index: _index, 
        content : _content
      }
      this.Cells[_index].metadata.version = 1
      axios.post('/save-xread-codes', _data, this.$store.getters.getAxiosConfig)
      .then((res) => {
          if (res.data.message != 'OK') {
            this.$store.commit('setFeedback', res.data.message)            
          }
      })
      .catch(error => {
          this.$store.commit('setFeedback', error)
      })   
    },
    preparePersonalCodes() {
      if (this.task_id == -1 || this.user_course_id == -1) return    

      const _data = {
        user_course_id : this.user_course_id,
        task_id : this.task_id,
        component_id : this.id, // not used now
      }
      axios.post('/get-xread-codes', _data, this.$store.getters.getAxiosConfig)
      .then((res) => {
          if (res.data.message == 'OK') {
            for(let i=0; i < res.data.codes.length; i++) {
               this.textToCell(res.data.codes[i].index, res.data.codes[i].code)
               this.Cells[res.data.codes[i].index].metadata.version = 1
            }
            this.code_update_finished = true
          } else {
            this.$store.commit('setFeedback', res.data.message)            
          }
      })
      .catch(error => {
          this.$store.commit('setFeedback', error+'aaaaaaaaaa')
      })
    },
    textToCell(_index, _content) {
      const _newCell = []      
      const _arr = _content.split("\n");
      for (let i = 0; i < _arr.length; i++) {
        if (i == _arr.length - 1)
          _newCell.push(_arr[i]);
        else _newCell.push(_arr[i] + "\n");
      }
      this.Cells[_index].source = JSON.parse(JSON.stringify(_newCell))
    },
    loadOriginalCode(_index) {
      // if current content and original code are different
      this.Cells[_index].metadata.version = 1
      if (this.my_elementA[_index].source.join('') != this.Cells[_index].source.join('')) {
        if (_index == this.activeContentIndex) {
          this.activeTmpContent = '' + this.my_elementA[_index].source.join('')
        } else {
          this.textToCell(_index, this.my_elementA[_index].source.join('')) 
          this.saveCode(_index, this.my_elementA[_index].source.join(''))
        }        
      }
    },
    loadCodeVersion(_index, _direction) {
      if (this.task_id == -1 || this.user_course_id == -1) return
      
      const _data = {
        user_course_id : this.user_course_id,
        task_id : this.task_id,
        component_id : this.id, // not used now
        index: _index,
        current_version: this.Cells[_index].metadata.version,
        direction : _direction
      }
      axios.post('/get-xread-codes-version', _data, this.$store.getters.getAxiosConfig)
      .then((res) => {
          if (res.data.message == 'OK' || (res.data.message == 'bound')) {
            if (res.data.message == 'OK') {
              if (_index == this.activeContentIndex) {
                this.activeTmpContent = '' + res.data.codes[0].code
              } else {
                this.textToCell(_index, res.data.codes[0].code)
              }
              this.Cells[_index].metadata.version = res.data.codes[0].version
            }
          } else {
            this.$store.commit('setFeedback', res.data.message)            
          }
      })
      .catch(error => {
          this.$store.commit('setFeedback', error)
      })      
    }
  },
};
</script>

<style>
.CodeMirror {
  border: 1px solid #eee;
  height: auto;
}
</style>
